/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Caption_File_TimecodesInputs */



/**
* | output |
* | --- |
* | "Event Group Timecodes are based on caption file" |
*
* @param {Offline_Sync_Caption_File_TimecodesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_caption_file_timecodes = /** @type {((inputs?: Offline_Sync_Caption_File_TimecodesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Caption_File_TimecodesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les timecodes du groupe d'événements sont basés sur un fichier de sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeitcodes der Ereignisgruppe basieren auf einer Untertiteldatei")
	if (locale === "it") return /** @type {LocalizedString} */ ("I timecode del gruppo eventi sono basati su un file sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Таймкоды группы событий основаны на файле субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los códigos de tiempo del grupo de eventos están basados en un archivo de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件组时间码基于字幕文件")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントグループのタイムコードは字幕ファイルに基づいている")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट समूह के टाइमकोड कैप्शन फ़ाइल पर आधारित हैं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Os códigos de tempo do grupo de eventos baseiam-se num ficheiro de legendas")
	return /** @type {LocalizedString} */ ("Event Group Timecodes are based on caption file")
});